<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
  <div class="flex flex-col gap-4">
    <div v-for="(claimField, index) of claimFields" v-bind:key="index"
         class="flex flex-col gap-2 border-2 border-base-200 rounded-md p-4">
      <div class="text-xl font-bold">
        <label-component :label="claimField.name" :postfix="`(claims.${claimField.field})`" />
      </div>

      <div class="overflow-x-auto w-full h-96">
        <table class="table w-full">
          <!-- head -->
          <thead>
          <tr>
            <th></th>

            <th>Name</th>
            <th>Claim</th>
          </tr>
          </thead>
          <tbody>

          <!-- rows -->
          <tr v-for="(claim, index) of claimsStore.getClaims" v-bind:key="index">
            <th>
              <label>
                <input type="checkbox"
                       class="checkbox"
                       :checked="hasClaim(claimField.field, claim.identifier)"
                       @change="change(claimField.field, claim.identifier)"
                />
              </label>
            </th>

            <td>{{ claim.name }}</td>
            <td>{{ claim.identifier }}</td>
          </tr>
          </tbody>

          <!-- foot -->
          <tfoot>
          <tr>
            <th></th>
            <th>Name</th>
            <th>Claim</th>
          </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <div v-if="isMode('update')" class="self-end">
      <button-component fa-icon="fa-regular fa-floppy-disk" @click="$emit('save')"></button-component>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useClaimsStore } from "@/stores/claims";
import ButtonComponent from "@/components/ButtonComponent";
import LabelComponent from "@/components/LabelComponent";

export default {
  name: "ClaimsTab",
  components: { LabelComponent, ButtonComponent },
  props: ["modelValue", "mode"],
  data() {
    return {
      client: undefined,
      claimFields: [
        {
          name: "Userinfo",
          field: "userinfo"
        },
        {
          name: "ID-Token",
          field: "id_token"
        }
      ]
    };
  },
  created() {
    this.client = this.modelValue;

    if (!this.client.claims)
      this.client.claims = {
        id_token: {},
        userinfo: {}
      };

    if (!this.client.claims.id_token)
      this.client.claims.id_token = {};

    if (!this.client.claims.userinfo)
      this.client.claims.userinfo = {};

    this.claimsStore.fetchClaims();
  },
  computed: {
    ...mapStores(useClaimsStore)
  },
  methods: {
    hasClaim(field, claim) {
      return claim in this.client.claims[field];
    },
    change(field, claim) {
      if (this.hasClaim(field, claim)) {
        delete this.client.claims[field][claim];
      } else {
        this.client.claims[field][claim] = true;
      }

      this.$emit("update:modelValue", this.client);
    },
    isMode(mode) {
      return this.mode === mode;
    }
  }
};
</script>

<style scoped>

</style>